var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_532",
    "data-name": "Grupo 532",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.667,
    height: 22.476,
    viewBox: "0 0 19.667 22.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 1.317,
    cy: 1.317,
    r: 1.317,
    transform: "translate(13.276 13.705)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2063",
    "data-name": "Caminho 2063",
    d: "M264.288,263.843a.878.878,0,0,0,.878-.878v-7.2a3.516,3.516,0,0,0-3.512-3.512H260.6v-3.1a5.269,5.269,0,0,0-10.536,0v3.1h-1.052a3.516,3.516,0,0,0-3.512,3.512v7.2a3.516,3.516,0,0,0,3.512,3.512h12.643a3.516,3.516,0,0,0,3.512-3.512.878.878,0,0,0-1.756,0,1.758,1.758,0,0,1-1.756,1.756H249.012a1.758,1.758,0,0,1-1.756-1.756v-7.2a1.758,1.758,0,0,1,1.756-1.756h12.643a1.758,1.758,0,0,1,1.756,1.756v7.2A.878.878,0,0,0,264.288,263.843Zm-5.445-11.589H251.82v-3.1a3.514,3.514,0,0,1,7.024,0Z",
    transform: "translate(-245.5 -244)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 1.317,
    cy: 1.317,
    r: 1.317,
    transform: "translate(6.972 13.705)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 1.317,
    cy: 1.317,
    r: 1.317,
    transform: "translate(3.841 13.705)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 1.317,
    cy: 1.317,
    r: 1.317,
    transform: "translate(10.103 13.705)",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.67c5c0453240b30c4e247d20327ab12b.svg";
export { ForwardRef as ReactComponent };